import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import React, { useContext, useEffect } from "react";
import { Table as TableType } from "../../../../services/tables/models";
import { Helmet } from 'react-helmet';
import PageStoreContext from "./context";

import TableForm from "./EditTableForm"
import { PageFormType } from "./store";

import {
    Button,
    Table,
    TableBody,
    TableContainer,
} from "@material-ui/core";

import { Add as AddIcon, Edit as EditIcon } from "@material-ui/icons";
import DeleteIcon from '@material-ui/icons/Delete';
import { EnhancedTableHead, HeadCell } from "../../../../common/components/TableHelpers";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import { Paper } from "../../../../common/components/libs";
import { FadeInOutVertical } from "../../../../common/components/Animated";
import DeleteTableForm from "./DeleteTableForm";
import { localize } from "../../../../common/libs";
import { Trans, useTranslation } from "react-i18next";


// const headCells: Array<HeadCell> = [
//     { id: 'publicId', alignment: 'left', label: 'Номер стола' },
//     { id: 'title', alignment: 'left', label: 'Название' },
//     { id: 'description', alignment: 'left', label: 'Описание' },
//     { id: 'actionTypes.ts', alignment: 'right', label: 'Действия' },
// ];


const TablesManagementPage = () => {
    const {i18n, t, ready} = useTranslation(["general", "menu"], { useSuspense: false });

    const headCells: Array<HeadCell> = [
        { id: 'publicId', alignment: 'left', label: t("menu:tables.tableNumber")},
        { id: 'title', alignment: 'left', label: t("general:name") },
        { id: 'description', alignment: 'left', label: t("general:description") },
        { id: 'description', alignment: 'left', label: t("menu:tables.externalId") },
        { id: 'actionTypes.ts', alignment: 'right', label: t("general:actions") },
    ];

    const { generalStore } = useStores();
    const pageStore = useContext(PageStoreContext);


    useEffect(() => {
        const HeaderButton = () => {
            return <Button variant="contained" color="primary"
                           onClick={() => {
                               showEditForm();
                           }}>
                <AddIcon/>
                {t("menu:tables.addTable")}
            </Button>
        };
        generalStore.setPageTitle(t("menu:tables.tables"), <HeaderButton/>);
        pageStore.loadTables();
    }, [generalStore, ready]);


    const showEditForm = async (item?: TableType) => {
        pageStore.openForm(PageFormType.editAndCreateTable, item)
    };
    const showDeleteForm = async (item?: TableType) => {
        pageStore.openForm(PageFormType.deleteTable, item)
    };


    const tables = pageStore.tables;

    return (

        <React.Fragment>
            <Helmet title={t("menu:tables.yourTables")}/>
            <FadeInOutVertical show={true}>
                <Paper>
                    <TableContainer>
                        <Table
                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead cells={headCells}/>
                            <TableBody>
                                {tables
                                    //не показываем системный стол
                                    .filter(item => item.data.publicId !== 0)
                                    .map((row: TableType, index: number) => {
                                        return (
                                            <TableRow
                                                hover
                                                tabIndex={-1}
                                                key={`${row.id}-${index}`}
                                            > <TableCell align="left">{row.data.publicId}</TableCell>
                                                <TableCell align="left">{localize(row.data.title)}</TableCell>
                                                <TableCell align="left">{localize(row.data.description)}</TableCell>
                                                <TableCell align="left">{row.externalId || "-"}</TableCell>

                                                <TableCell padding="none" align="right">
                                                    <Box mr={2}>
                                                        <IconButton aria-label="delete"
                                                                    onClick={() => showEditForm(row)}>
                                                            <EditIcon/>
                                                        </IconButton>
                                                        <IconButton aria-label="delete"
                                                                    onClick={() => showDeleteForm(row)}>
                                                            <DeleteIcon/>
                                                        </IconButton>

                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </FadeInOutVertical>
            <TableForm/>
            <DeleteTableForm/>
        </React.Fragment>
    );

};


export default observer(TablesManagementPage);
